import cookie from "react-cookies";
import _ from "underscore";
import config from '../../config';
import moment from "moment";
import React from "react";
// Never remove following line async-await
import regeneratorRuntime from "regenerator-runtime";
import appErrorLogger from "./DataDogErrorLog";
import {Button} from "react-bootstrap";
import ProductsCarouselNextArrow from "./ProductsCarouselNextArrow";
import ProductsCarouselPrevArrow from "./ProductsCarouselPrevArrow";
import LpNewPrevArrow from "./LpNewPrevArrow";
import LpNewNextArrow from "./LpNewNextArrow";
import { cartHasShippingProtection, isCartLineItemShippingFee, isCartLineItemSubscription } from "../cart/helpers"

export const getExpirationMessage = (expiration_in_days) => {
    let expiration_message = "Expires today";
    if(expiration_in_days >= 1){
        expiration_message = "Expires in one day"
    }
    if(expiration_in_days >= 2){
        expiration_message = `Expires in ${expiration_in_days} days`
    }

    return expiration_message;
};

export const addNoScroll = (class_name) => {
    if(window.scrollY !== 0){
        sessionStorage.setItem("modal_scroll_position", window.scrollY);
    }
    document.body.classList.add(class_name);
    document.getElementsByTagName('html')[0].classList.add(class_name);
    return null;
};

export const addSelectiveNoScroll = (class_name) => {
    if(window.scrollY !== 0){
        sessionStorage.setItem("modal_selective_scroll_position", window.scrollY);
    }
    document.body.classList.add(class_name);
    document.getElementsByTagName('html')[0].classList.add(class_name);
    return null;
};

export const removeNoScroll = (class_name) => {
    const scroll_position = sessionStorage.getItem("modal_scroll_position");
    document.body.classList.remove(class_name);
    document.getElementsByTagName('html')[0].classList.remove(class_name);
    if(scroll_position) {
        setTimeout(function(){
            window.scrollTo(0, scroll_position);
            sessionStorage.removeItem("modal_scroll_position");
        }, 0);
    }
    return null;
};

export const removeSelectiveNoScroll = (class_name) => {
    const scroll_position = sessionStorage.getItem("modal_selective_scroll_position");
    document.body.classList.remove(class_name);
    document.getElementsByTagName('html')[0].classList.remove(class_name);
    if(scroll_position) {
        setTimeout(function(){
            window.scrollTo(0, scroll_position);
            sessionStorage.removeItem("modal_selective_scroll_position");
        }, 0);
    }
    return null;
};

export const getCurrencyType = (currency_type_key, currency_type_default_value) => {
    return sessionStorage.getItem('other_currency_type') ? JSON.parse(sessionStorage.getItem('other_currency_type'))[currency_type_key] : currency_type_default_value
};

export const extractProductIdFromStoreFrontId = (product_id) => {
    return parseInt(product_id.split("/")[4]) || null;
};

export const encodeProductIdToStoreFrontId = (product_id) => {
    const shop_prefix = "gid://shopify/ProductVariant/";
    return btoa(shop_prefix + product_id) || null;
}

export const productVariantIdToStoreFrontVariantId = (product_id) => {
    return `gid://shopify/ProductVariant/${product_id}` || null;
}

export const prepareShopifyUrl = (query) => {
    return query ? query.replace(/%5B/g, '').replace(/%5D/g, '') : null;
};

export const authCheck = () => {
    const auth_token = getCookie("auth_token");
    return !!auth_token;
};

export const getImageSize = (source_url, img_size = 100) => {
    const rx = /\.(\w+)([?]{1})/g;
    return source_url.replace(rx, `_${img_size}x${img_size}.$1?`);
};

export const getImageBySizeFromCDN = (source_url, format = 'quality=100') => {
    const cdn_prefix = `https://rebag.com/cdn-cgi/image`;
    // const cdn_prefix = `${config.host_rebag}/cdn-cgi/image`;
    const encoded_format = encodeURIComponent(format);
    return `${cdn_prefix}/${encoded_format}/${source_url}`;
}

export function isJsonString(str) {
    let value = typeof str !== "string" ? JSON.stringify(str) : str;
    try {
        value = JSON.parse(value);
    } catch (e) {
        return false;
    }

    return typeof value === "object" && value !== null;
}

export const extractOptionFromBC = (filterOptionId) => {
    return config.plpFilters[filterOptionId] || [];
}

export const extractStyleAssemblyCollectionsMapFromConfig = () => {
    const style_assembly_influencer_list = config.style_assembly_influencer_list;
    let style_assembly_collections_map = {};

    if (style_assembly_influencer_list && style_assembly_influencer_list.length > 0) {
        _.map(style_assembly_influencer_list, function(style_assembly_influencer){
            if (style_assembly_influencer.shop_filter) {
                style_assembly_collections_map = {...style_assembly_collections_map, ...style_assembly_influencer.shop_filter};
            }
        });
    }

    return style_assembly_collections_map;
}

export const countNonEmptyCollections = (collections) => {
    let collections_with_products = 0;
    _.map(collections, (collection) => {
        if (!_.isEmpty(collection.products)) {
            return collections_with_products++;
        }
    });
    return collections_with_products;
}

export const removeEmptyKeysFromObject = (collection_object) => {
    return _.pick(collection_object, function(value) {
        const is_b2b = getCookie('is_b2b');
        if (Object.keys(value).length && value.collection && (value.collection_filter_key !== "bc-filter-extra-tags-b2b-vip" || (value.collection_filter_key === "bc-filter-extra-tags-b2b-vip" && is_b2b))) {
            return value;
        }
    });
}

export const getBonusRebagCredit = (offer, user_profile) => {
    let bonus_reward = 0;
    const init = localStorage.getItem('init') ? JSON.parse(localStorage.getItem('init')) : null;
    const seller_incentive_item_type_tiered = init && init.seller_incentive_item_type_tiered;
    if(seller_incentive_item_type_tiered && (seller_incentive_item_type_tiered.show_for === "all" || (seller_incentive_item_type_tiered.show_for === "new" && user_profile && user_profile.is_new))) {
        const offer_price = offer && offer.prices && offer.prices.normal_price;
        const offer_item_type = offer && offer.sku && offer.sku.split(".")[0];
        const item_type_valid = _.find(seller_incentive_item_type_tiered.item_types, function(item_type){ return offer_item_type === item_type; });
        if (item_type_valid) {
            seller_incentive_item_type_tiered.tiers.forEach((tier) => {
                if(offer_price.value >= tier.min_value){
                    bonus_reward = tier.incentive;
                }
            })
        }
    }

    return bonus_reward;
}

export const isBetweenDates = (start_date_string, end_date_string) => {
    const urlParams = new URLSearchParams(window.location.search);
    const current_date = urlParams.has('current_date') ? moment.utc(urlParams.get('current_date')) : moment.utc();
    const start_date = moment.utc(start_date_string);
    const end_date = moment.utc(end_date_string);

    return current_date.isBetween(start_date, end_date);
}

export const getCookie = (key) => {
    return cookie.load(key, {path: '/', domain: config.cookie_domain});
}

export const setCookie = (key, value, expiration_value = 15, expiration_label='days') => {
    const cookie_settings = {
        path: '/',
        domain: config.cookie_domain,
        expires: moment().add(expiration_value, expiration_label).toDate()
    }

    cookie.save(key, value, cookie_settings);
}

export const deleteCookie = (key) => {
    return cookie.remove(key, {path: '/', domain: config.cookie_domain});
}

export const startTrading = (before_trade_in, isCartOpen = false) => {
    setCookie('before_trade_in', before_trade_in, 1);
    window.location.href = `${config.host_rebag}/trade-in/${isCartOpen ? '?cart=open' : ''}`;
}

export const exitTrading = () => {
    const before_trade_in = getCookie('before_trade_in') || `${config.host_rebag_shop}/collections/new-arrivals`;
    deleteCookie('before_trade_in');
    if(before_trade_in.indexOf('cart=open') === -1){
        window.location.href = `${before_trade_in}${before_trade_in.indexOf('?') !== -1 ? '&' : '?'}cart=open`;
    } else {
        window.location.href = before_trade_in;
    }
}

export const clearTradeItemsFromSession = () => {
    sessionStorage.removeItem("trade_in_bags");
    sessionStorage.removeItem("trade_in_state");
    sessionStorage.removeItem('trade_in_shipping_method');
    sessionStorage.removeItem('trade_in_store')
    sessionStorage.removeItem('trade_in_address_id')
}

export const detectPlatformChange = () => {
    const currentPlatform = window.location.host;
    const sourcePlatformCookie = getCookie("currentPlatform");
    if (sourcePlatformCookie !== currentPlatform) {
        setCookie('currentPlatform', currentPlatform, 30);
        try {
            window.dataLayer.push({
                "event": "Cross Domain Nav",
                "source": sourcePlatformCookie,
                "destination": window.location.href,
            });
        } catch (err) {
            appErrorLogger("Cross Domain Nav Error", err)
        }
    }
}

export const buildClairPVTitle = (clair_offer) => {
    return `
        ${clair_offer.designer || ""} 
        ${clair_offer.model ? ' - ' + clair_offer.model : ""} 
        ${clair_offer.style ? ' - ' + clair_offer.style : ""} 
        ${clair_offer.size ? ' - ' + clair_offer.size : ""} 
        ${clair_offer.color ? ' - ' + clair_offer.color.replace(/^(.)|\s+(.)/g, ($1) => {
            return $1.toUpperCase()
        }) : ''}
        ${clair_offer.accessories.length > 0 ? ' - ' + clair_offer.accessories.join(" - ") : ''}
        ${clair_offer.grade ? ' - ' + clair_offer.grade : ''}
        `;
}

export const tradeInBagsTotal = (trade_in_bags) => {
    return trade_in_bags && trade_in_bags.length > 0 ? _.reduce(_.pluck(trade_in_bags, "prices"), (memo, price) => {return memo + price.instant_trade_in.value}, 0) : 0;
}

export const formatLabel = (label, value) => {
    if (!value) {
        return label;
    }
    const search_regex = new RegExp(value, 'i');
    const matched_word = label.match(search_regex)[0];
    return (
        <>
            {label.split(search_regex)
                .reduce((prev, current, i) => {
                    if (!i) {
                        return [current];
                    }
                    return prev.concat(<strong key={value + current}>{matched_word}</strong>, current);
                }, [])
            }
        </>
    )
}

export const getExperimentId = () => {
    const cookie = getCookie('_gaexp');
    if (cookie == undefined) {
        return undefined;
    } else {
        const fields = cookie.split('.');
        return fields[2];
    }
}

export const getVariationId = () => {
    const cookie = getCookie('_gaexp');
    if (cookie == undefined) {
        return undefined;
    } else {
        const fields = cookie.split('.');
        return fields[4];
    }
}

export const validateEmail = (email) => {
    const blacklist = ['@all.com', '@ail.com', '@gnail.com', '@yahooo.com', '@yaho.com'];
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1}\.[0-9]{1}\.[0-9]{1}\.[0-9]{1}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;
    for (let i = 0; i < blacklist.length; i++) {
        if (email.toLowerCase().indexOf(blacklist[i]) !== -1) {
            return false;
        }
    }
    if (email.substr(email.length - 4) === ".con") {
        return false;
    }
    if (email.substr(email.length - 5) === ".comm") {
        return false;
    }
    return re.test(email);
}

export const getProductCollection = (tags) => {
    if(_.indexOf(tags, 'bc-filter-Accessories') !== -1){
        return 'all-accessories';
    }
    if(_.indexOf(tags, 'bc-filter-Jewelry') !== -1){
        return 'new-arrivals';
    }
    if(_.indexOf(tags, 'bc-filter-Watches') !== -1){
        return 'new-arrivals'
    }

    return 'all-bags';
}

export const getShopifyProductUrl = (product) => {
    const {handle, onlineStoreUrl, allMeta} = product;
    return handle ? `${config.host_rebag_shop}/products/${handle}` : onlineStoreUrl || `${config.host_rebag_shop}/products/${allMeta?.attributes?.handle?.text[0]}`;
}

export const canSeeFirstLook = (user_profile) => {
    const is_b2b = user_profile?.is_b2b;
    if(is_b2b){
        return true;
    }

    const current_tier = user_profile.tier.tier_key;
    const init = localStorage.getItem('init');
    if(init){
        const {rewards_tiers} = JSON.parse(init);
        if(rewards_tiers && rewards_tiers[current_tier]){
            return rewards_tiers[current_tier].rank > 4;
        }
    }
    return false;
}

export const getTierByTierKey = (next_tier_key) => {
    const init = localStorage.getItem('init');
    if(init){
        const {rewards_tiers} = JSON.parse(init);
        if(rewards_tiers && rewards_tiers[next_tier_key]){
            return rewards_tiers[next_tier_key];
        }
    }
    return {rank: 0};
}

export const extractUserName = (user_profile) => {
    if(user_profile){
        return user_profile.first_name ? user_profile.first_name : user_profile.email;
    }
    return '!';
}

export const copyToClipboard = (e, codeSelectHelper) => {
    codeSelectHelper.current.type = "text";
    codeSelectHelper.current.select();
    document.execCommand('copy');
    codeSelectHelper.current.type = "hidden";
    e.target.focus();

    return null;
}

export const filterBannersByTier = (banners, current_tier_rank) => {
    const filtered_by_tier =  _.filter(banners, (banner) => {
        if (banner.for_new_customers_only) {
            return current_tier_rank === 0;
        } else if (!banner.starting_from_tier) {
            return current_tier_rank < 5;
        } else {
            return banner.starting_from_tier && banner.starting_from_tier_rank <= current_tier_rank;
        }
    }) || [];

    if(authCheck()){
        return filtered_by_tier;
    }

    return _.filter(filtered_by_tier, (banner) => {
        return banner.for_logged_in_only === false;
    }) || []
}

export const computePotentialRewardPoints = (cart, trade_in_bags, seller_incentive_tier, points_limit_per_tier) => {
    const total_trade_in = tradeInBagsTotal(trade_in_bags);
    let productAppliedDiscounts = 0;
    let total_points = getSellerIncentiveMultipliedPoints(total_trade_in, seller_incentive_tier, 'trade', points_limit_per_tier);
    if(cart && cart.cost?.subtotalAmount?.amount){
        const {lines} = cart;
        cart.discountAllocations.forEach((discountAllocation) => {
            if (['POINTS VALUE', 'TRADE ITEMS VALUE'].includes(discountAllocation.title)) {
                productAppliedDiscounts = productAppliedDiscounts + parseFloat(discountAllocation.discountedAmount.amount);
            }
        })
        filterSubscriptionAndShippingFee(lines).forEach((cartLine) => {
            cartLine.discountAllocations.forEach(discountAllocation => {
                if (discountAllocation.title === 'R+ Discount') {
                    productAppliedDiscounts += parseFloat(discountAllocation.discountedAmount.amount);
                }
            })
            const product_price_with_discount = parseFloat(cartLine.merchandise.price.amount) - productAppliedDiscounts;
            total_points += getSellerIncentiveMultipliedPoints(product_price_with_discount, seller_incentive_tier, 'sell', points_limit_per_tier);
        })
    }
    return total_points;
}

export const nextTierByRewardPoints = (reward_points) => {
    let next_tier = null;
    const init = localStorage.getItem('init');
    if(init){
        const {rewards_tiers} = JSON.parse(init);
        if(rewards_tiers){
            _.map(rewards_tiers, (tier) => {
                if(tier.tier_value <= reward_points){
                    next_tier = tier;
                }
            });
        }
    }
    return next_tier;
}

export const nextDayInNeed = (dayINeed) => {
    const day_format = 'YYYY-MM-DD 08:00:00';
    const today = moment().isoWeekday();
    if (today < dayINeed) {
        return moment.utc().isoWeekday(dayINeed).format(day_format);
    } else {
        return moment.utc().add(1, 'weeks').isoWeekday(dayINeed).format(day_format);
    }
}

export const vipPreviewTimers = () => {
    const {vip_preview_week_day, vip_preview_duration, vip_preview_start_date_override} = config.vip_preview;

    const today = moment.utc(new Date());
    const future_date_override = moment(vip_preview_start_date_override);
    const is_override_date_in_future = future_date_override.isAfter(today);
    const vip_preview_ends_at = moment(is_override_date_in_future ? future_date_override : nextDayInNeed(vip_preview_week_day));
    const duration = moment.duration(vip_preview_ends_at.diff(today));
    const hours = duration.asHours();

    return {
        vip_preview_ends_at: vip_preview_ends_at,
        vip_preview_duration: vip_preview_duration,
        must_show_generic_message: hours > 0 && hours <= (vip_preview_duration + 24),
        must_show_vip_message: hours > 0 && hours <= vip_preview_duration,
        must_show_navbar_message: hours >= vip_preview_duration || hours <= 0
    }
}

export const getSellerIncentiveByTier = (user_tier) => {
    const init = localStorage.getItem("init") ? JSON.parse(localStorage.getItem("init")) : null;
    const tier_key = user_tier ? user_tier.tier_key : 'no_tier';
    const rewards_tiers = init ? init.rewards_tiers : null;

    if (tier_key && rewards_tiers && rewards_tiers[tier_key].seller_incentive) {
        return rewards_tiers[tier_key].seller_incentive;
    }
    return null;
}

export const getUserPointsLimitByTier = (user_tier) => {
    const init = localStorage.getItem("init") ? JSON.parse(localStorage.getItem("init")) : null;
    const tier_key = user_tier ? user_tier.tier_key : 'no_tier';
    const rewards_tiers = init ? init.rewards_tiers : null;

    if (tier_key && rewards_tiers && rewards_tiers[tier_key].lp_item_limit) {
        return rewards_tiers[tier_key].lp_item_limit;
    }
    return null;
}

export const getSellerIncentiveMultipliedPoints = (current_points, seller_incentive_tier, incentive_type, points_limit) => {
    const multiplied_points = seller_incentive_tier ? Math.ceil(seller_incentive_tier[incentive_type].value * current_points) : current_points;
    return multiplied_points > points_limit ? points_limit : multiplied_points;
}

export const getCurrentUserRank = (user_tier) => {
    const init = localStorage.getItem("init") ? JSON.parse(localStorage.getItem("init")) : null;
    const rewards_tiers = init ? init.rewards_tiers : null;
    if (rewards_tiers) {
        return rewards_tiers[user_tier.tier_key].rank;
    } else {
        return 0;
    }
}

export const arrayHasEmptyStrings = (token) => {
    for (var i = 0; i < token.length; i++) {
        if (token[i] === "") {
            return false;
        }
    }
    return true;
}

export const displayAttentiveModal = (attempt_count = 0, creativeIdMobile, creativeIdDesktop) => {
    if (typeof window.__attentive !== 'undefined' && typeof window.__attentive.trigger !== 'undefined') {
        const attentive_resolution_trigger = window.innerWidth < 768 ? creativeIdMobile || '246312' : creativeIdDesktop || '246318';
        window.__attentive.trigger(null, null, null, attentive_resolution_trigger);
    } else if (attempt_count < 3) {
        setTimeout(() => displayAttentiveModal(++attempt_count), 1000);
    } else {
        const attentive_input_container = document.querySelector(".footer-signup-container__input-container-attentive, .offer-coupon__input-container-attentive");
        const newsletter_input_container = document.querySelector(".footer-signup-container__input-container, .offer-coupon__input-container");
        attentive_input_container && attentive_input_container.classList.add("d-none");
        newsletter_input_container && newsletter_input_container.classList.remove("d-none");
    }
}

export const formattedAddress = (address) => {
    return (
        {
            name: `${address.first_name} ${address.last_name}`,
            address: `${address.address1 ? `${address.address1}, `  : ''}
                        ${address.city ? `${address.city}, ` : ''}
                        ${address.province ? `${address.province}, ` : ''}
                        ${address.zip ? `${address.zip}, ` : ''}`,
            phone: address.phone
        }
    )
}

export const formattedAddressSellNow = (address) => {
    return `${address.first_name ? `${address.first_name} ` : ""}${address.last_name ? `${address.last_name}, ` : ""}${address.address ? `${address.address}, ` : ""}${address.city ? `${address.city}, ` : ""}${address.state ? `${address.state}, ` : ""}${address.zipcode ? `${address.zipcode}` : ""}${address.phone ? `, ${address.phone}` : ""}`;
}

export const getRebagCreditPercentage = () => {
    const init = localStorage.getItem('init') ? JSON.parse(localStorage.getItem('init')) : null;
    return (init && init.site_credits_percent * 100) || 0;
}

export const isInCheckoutOrTYPage = () => {
    return config.host_rebag_shop.includes(window.location.host) && (window.location.pathname.includes('/orders/') || window.location.pathname.includes('/checkouts/'));
}

export const isTYPage = () => {
    return config.host_rebag_shop.includes(window.location.host) && (window.location.pathname.includes('/thank_you') || window.location.pathname.includes('/orders/'));
}

export const handleVerifyRecaptcha = async (googleReCaptchaProps, action) => {
    const { executeRecaptcha } = googleReCaptchaProps;

    if (!executeRecaptcha) {
        appErrorLogger('Handle Verify Recaptcha', {'message': 'Recaptcha has not been loaded'})
        return;
    }

    return await executeRecaptcha(action);
}

export const getStoreById = (storeId) => {
    const init = localStorage.getItem('init') ? JSON.parse(localStorage.getItem('init')) : null;
    return init && _.find(init.stores, (store) => {
        return storeId === store.id;
    });
}

export const urlencodeFormData = (fd) => {
    var s = '';
    function encode(s){ return encodeURIComponent(s).replace(/%20/g,'+'); }
    for(var pair of fd.entries()){
        if(typeof pair[1]=='string'){
            s += (s?'&':'') + encode(pair[0])+'='+encode(pair[1]);
        }
    }
    return s;
}

export const setIntercomUserDetails = (userObj) => {
    if (typeof window.Intercom === "function") {
        if (userObj.email) {
            window.intercomSettings["email"] = userObj.email;
        }
        if (userObj.created_at) {
            window.intercomSettings["created_at"] = parseInt((new Date(userObj.created_at).getTime() / 1000).toFixed(0));
        }
        if (userObj.first_name && userObj.last_name) {
            window.intercomSettings["name"] = `${userObj && userObj.first_name} ${userObj && userObj.last_name}`;
        }
        else if (userObj.first_name) {
            window.intercomSettings["name"] = userObj.first_name;
        }
        else if (userObj.last_name) {
            window.intercomSettings["name"] = userObj.last_name;
        }
        if(userObj.shopify_id && userObj.intercom_user_hash){
            window.intercomSettings["user_id"] = userObj.shopify_id
            window.intercomSettings["user_hash"] = userObj.intercom_user_hash
        }
        window.Intercom("update");
    }
}

export const carouselSettings = (slider_settings) => {
    return {
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        swipeToSlide: window.innerWidth <= 768,
        responsive: config.slider_responsive,
        nextArrow: <ProductsCarouselNextArrow />,
        prevArrow: <ProductsCarouselPrevArrow />,
        customPaging: (index) => {
            return (
                <Button
                    variant="clean"
                    className="custom-slick-dot"
                    aria-label={`Slide Page ${index + 1}`}
                >
                    <span className="custom-slick-dot__inner"/>
                </Button>
            )
        },
        ...slider_settings,
    }
}

export const carouselSettingsMostWanted = (slider_settings, mobile_big) => {
    return {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        swipeToSlide: window.innerWidth <= 768,
        responsive: config.slider_responsive,
        nextArrow: <LpNewNextArrow
            customClass="most-wanted-lp__carousel-btn most-wanted-lp__carousel-btn--next"
            stroke={mobile_big ? "black" : "white"}
            customStyle={{width: mobile_big ? 6 : 8}}
        />,
        prevArrow: <LpNewPrevArrow
            customClass="most-wanted-lp__carousel-btn most-wanted-lp__carousel-btn--prev"
            stroke={mobile_big ? "black" : "white"}
            customStyle={{width: mobile_big ? 6 : 8}}
        />,
        customPaging: (index) => {
            return (
                <Button
                    variant="clean"
                    className="custom-slick-dot"
                    aria-label={`Slide Page ${index + 1}`}
                >
                    <span
                        className="custom-slick-dot__inner inner-focus"
                    />
                </Button>
            )
        },
        ...slider_settings,
    }
}

export const productTagsGraphToArray = (tags) => {
    return _.pluck(tags, 'value');
}

export const isSearchUrl = () => {
    return window.location.href.includes("/search?");
}

export const getSavedSearchFilterString = (appliedFilters) => {
    let filterString = '';
    appliedFilters.forEach(selectedFilter => {
        filterString += selectedFilter.name + ', ';
    });
    return filterString;
}

export const deleteAllSearchParams = () => {
    const url = new URL(window.location.href);
    url.search = "";
    history.pushState({}, '', url);
}

export const getPriceDrop = (current_price, original_price) => {
    if(parseInt(current_price) >= 5000 && parseInt(current_price)/parseInt(original_price) < 0.75){
        return 0
    }
    return parseInt(original_price)
}

export const mustShowExtraTag = (product_extra_tag, has_pricedrop_tag, is_b2b) => {
    if(product_extra_tag === "bc-filter-extra-tags-b2b-vip"){
        return is_b2b
    } else if(has_pricedrop_tag && 'bc-filter-extra-tags-investment_piece' === product_extra_tag){
        return false
    }

    return true
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatConsignStatus = (status) => {
    const arraySplit = status.split('_');
    arraySplit.forEach((string, index) => arraySplit[index] = capitalizeFirstLetter(string));
    return arraySplit.join(' ');
}

export const getInProductMKTPopupSettings = (user_profile) => {
    const activeMembership = user_profile && isRPlusMembershipActive(user_profile);
    const showPendingOfferToast = authCheck() && user_profile && user_profile.has_orders_not_shipped && !sessionStorage.getItem("pending_offer_toast_opened");
    const showConsignmentToast = window.location.pathname.includes("/sell-now/") && (!showPendingOfferToast || !!sessionStorage.getItem("pending_offer_toast_opened")) && !sessionStorage.getItem("consignment_toast_opened");
    const showRPlusSellNowToast = window.location.pathname.includes("/sell-now/") && !window.location.pathname.includes("offer") && !activeMembership;

    let toastPayload = null;

    if (showPendingOfferToast) {
        toastPayload = {
            toastName: "pending_offer_toast",
            ctaURL: `${config.host_rebag}/my-account/submissions/`,
            textLabel: "Don't forget to ship your item",
            ctaLabel: "View pending orders"
        }
    } else if (showConsignmentToast) {
        toastPayload = {
            toastName: "consignment_toast",
            ctaURL: `${config.host_rebag}/consign/`,
            textLabel: "New to Rebag: Consignment",
            ctaLabel: "Learn More"
        }
    } else if (showRPlusSellNowToast) {
        toastPayload = {
            toastName: "rplus_sellnow_toast",
            ctaURL: `${config.host_rebag}/membership/`,
            textLabel: "Earn More with Rebag⁺",
            ctaLabel: "Learn More"
        }
    }

    return toastPayload;
}

export const checkUTMParams = () => {
    const queryParams = new URLSearchParams(window.location.search);

    if (['cpc'].includes(queryParams.get('utm_medium'))) {
        sessionStorage.setItem('is_from_cpc', '1');
    }

    if (sessionStorage.getItem('is_from_paid_campaign')) {
        return true;
    } else if (['Google', 'YT_'].includes(queryParams.get('g_campaign'))) {
        sessionStorage.setItem('is_from_paid_campaign', '');
        return false;
    } else if (['paid-social', 'cpc', 'display'].includes(queryParams.get('utm_medium'))) {
        sessionStorage.setItem('is_from_paid_campaign', '1');
        return true;
    }

    return false;
}

export const checkIfHidePromoMessage = (tag) => {
    return tag === "CL22" && !sessionStorage.getItem("is_from_cpc");
}

export const getDiscount = (discountAllocations, lineItems=[]) => {
    let discount = {code: null, discountedAmount: {amount: 0, currencyCode: 'USD'}, targetType: ''};
    let pointsAppliedDiscount = 0;
    let tradesAppliedDiscount = 0;
    discountAllocations.forEach(discountAllocation => {
      if (discountAllocation.code) {
          discount.code = discountAllocation.code;
          discount.targetType = discountAllocation.targetType;
          discount.discountedAmount.amount += parseFloat(discountAllocation.discountedAmount.amount);
      } else if (discountAllocation.title === 'POINTS VALUE') {
          pointsAppliedDiscount += parseFloat(discountAllocation.discountedAmount.amount);
      } else if (discountAllocation.title === 'TRADE ITEMS VALUE') {
          tradesAppliedDiscount += parseFloat(discountAllocation.discountedAmount.amount);
      }
    })

    lineItems.forEach(lineItem => {
        lineItem.discountAllocations.forEach(discountAllocation => {
            if (discountAllocation.code) {
                discount.code = discountAllocation.code;
                discount.targetType = discountAllocation.targetType;
                discount.discountedAmount.amount += parseFloat(discountAllocation.discountedAmount.amount);
            }
        })
    })
    return {discount, pointsAppliedDiscount, tradesAppliedDiscount};
}

export const mapProductsToRewardsPlusDiscount = (cartLines) => {
    let totalRewardsDiscount = 0;
    let lineItemsDiscountedSubtotal = 0;
    const mappedProducts = filterSubscriptionAndShippingFee(cartLines).map(cartLine => {
        const discountedPrice = getRewardsPlusDiscountThreshold(parseFloat(cartLine.merchandise.price.amount));
        cartLine.discountedPrice = discountedPrice;
        lineItemsDiscountedSubtotal += discountedPrice;
        totalRewardsDiscount += parseFloat(cartLine.merchandise.price.amount) - discountedPrice
        return cartLine
    })
    return {mappedProducts, lineItemsDiscountedSubtotal, totalRewardsDiscount}
}

export const filterSubscriptionAndShippingFee = (cartLines) => {
    return cartLines.filter(cartLine => !isCartLineItemSubscription(cartLine) && !isCartLineItemShippingFee(cartLine))
}

export const getRewardsPlusDiscountThreshold = (price) => {
    let threshold = null;
    for (let i = 0; i < config.subscription_discount_thresholds.length; i++ ) {
        if (price >= config.subscription_discount_thresholds[i].threshold) {
            threshold = config.subscription_discount_thresholds[i + 1];
        }
    }
    if(!threshold) threshold = config.subscription_discount_thresholds[0];
    if (threshold.discount_type === 'fixed') {
        return price - threshold.discount_amount;
    } else {
        return price - (price * threshold.discount_amount) / 100;
    }
}

export const checkActiveLabels = (rewards_membership_status) => {
    return ["active", "active_initial_access"].includes(rewards_membership_status);
}

export const isRPlusMembershipActive = (user_profile) => {
    return user_profile && checkActiveLabels(user_profile.rewards_membership_status);
}

export const isRPlusMembershipInactive = (user_profile) => {
    return !user_profile || (["suspended", "cancelled"].includes(user_profile.rewards_membership_status) || !user_profile.rewards_membership_status);
}

export const isRPlusMembershipSkipped = (user_profile) => {
    return user_profile && (["skipped"].includes(user_profile.rewards_membership_status));
}

export const isRPlusMembershipDisabled = (user_profile) => {
    return user_profile && (["skipped", "suspended", "cancelled"].includes(user_profile.rewards_membership_status));
}

export const getSubscriptionChargeDate = () => {
    const today = moment(new Date());
    return moment(today).add(config.subscription_nr_of_days_payment_delay, 'days').format("M/D");
}

export const getSubscriptionTypeLabel = (subscriptionMembershipType) => {
    return subscriptionMembershipType === "yearly" ? "yearly" : "monthly";
}

export const getSubscriptionChargeDay = (chargeDate) => {
    return moment(chargeDate, 'M/D').format('D');
}

export const checkSubscriptionStatus = (cart) => {
    let subscriptionOnlyCart = false;
    let isSubscriptionInCart = false;
    let subscriptionOnlyAlternatePaymentFlow = false;
    let subscriptionOnlySellNow = false;
    let subscriptionMembershipType = '';
    let shippingProtectionItem = false;

    if (cart) {
        cart.lines.forEach((lineItem) => {
            if (lineItem.merchandise.id === config.subscriptions.zeroCostItem.variantId) {
                isSubscriptionInCart = true;
            } else if (config.subscriptions.monthly.filter(sub => sub.merchandiseId === lineItem.merchandise.id)[0]) {
                isSubscriptionInCart = true;
                subscriptionMembershipType = 'monthly';
            } else if (config.subscriptions.yearly.filter(sub => sub.merchandiseId === lineItem.merchandise.id)[0]) {
                isSubscriptionInCart = true;
                subscriptionMembershipType = 'yearly';
            }
            if (isCartLineItemShippingFee(lineItem)) {
                shippingProtectionItem = true;
            }
        })
        if (isSubscriptionInCart && cart.lines.length === 1) {
            subscriptionOnlyCart = true;
        }
        if (cart.note === 'subscriptionOnlyAlternatePaymentFlow') {
            subscriptionOnlyAlternatePaymentFlow = true;
        }
        if (cart.note === 'subscriptionOnlySellFlow') {
            subscriptionOnlySellNow = true;
        }
    }
    return {subscriptionOnlyCart, isSubscriptionInCart, subscriptionOnlyAlternatePaymentFlow, subscriptionMembershipType, subscriptionOnlySellNow}
}

export const applyWalletObject = (stateObject) => {
    const {wallet_cash, rewards_credit, points} = stateObject.myAccountReducer.user_profile;
    const {user_gift_card_total} = stateObject.myAccountReducer;
    const {is_trade_in_page} = stateObject.appReducer;
    const {use_rebag_credit_request_in_progress} = stateObject.shopifyReducer;
    const applyRebagCredit = !is_trade_in_page && !use_rebag_credit_request_in_progress && user_gift_card_total > 0;

    return {
        applyRebagCredit,
        applyWalletCash: wallet_cash > 0,
        applyPoints: points >= 1000,
        applyRewardsCredit: rewards_credit > 0,
    }
}

export const calculateRefundAmount = (refundInfo) => {
    return (refundInfo.total_contribution - Math.abs(refundInfo.credits_used)) > 0 ? refundInfo.total_contribution - Math.abs(refundInfo.credits_used) : 0
}

export const getcurrentSellNowStep = (current_step, activeMembership) => {
    // return activeMembership ? current_step : current_step + 1;
    return current_step + 1;
}

export const calculateLineItemsStandardPrice = (lineItems) => {
    return filterSubscriptionAndShippingFee(lineItems).reduce((total, item) => total + parseFloat(item.merchandise.price.amount), 0)
}